import { StateSlice } from '@/stores/appStore';
import type { Paper, PaperId } from './paperSlice';
import { StateCreator } from 'zustand';

export type SelectionSlice = {
  selectedIdsList: Record<PaperId, boolean>;
  setSelectedIdsList: (list: Record<PaperId, boolean>) => void;
  toggleSelected: (id: PaperId, selected: boolean) => void;
  toggleCurrentPageRowsSelected: (items: Paper[], selected: boolean) => void;
  getIsSelected: (id: PaperId) => boolean;
  getIsCurrentPageRowsSelected: (items: Paper[]) => boolean | 'indeterminate';
  resetRowSelection: () => void;
};

export const createSelectionSlice: StateCreator<SelectionSlice, [], [], SelectionSlice> = (set, get) => ({
  selectedIdsList: {},
  setSelectedIdsList: (list) => set({ selectedIdsList: list }),
  toggleSelected: (id, selected) => set(state => {
    if (state.selectedIdsList[id] !== selected) {
      return { selectedIdsList: { ...state.selectedIdsList, [id]: selected } };
    }
    return {};
  }),
  toggleCurrentPageRowsSelected: (items, selected) => set(state => {
    const newList: Record<PaperId, boolean> = {};
    items.forEach(item => { newList[item.paperId] = selected; });
    const notSame = Object.keys(newList).some(id => state.selectedIdsList[id] !== selected);
    if (notSame) {
      return { selectedIdsList: { ...state.selectedIdsList, ...newList } };
    }
    return {};
  }),
  getIsSelected: (id) => get().selectedIdsList[id] === true,
  getIsCurrentPageRowsSelected: (items) => {
    const selectedItems = items.filter(item => !!get().selectedIdsList[item.paperId]);
    const len = selectedItems.length;
    if (len === items.length) return true;
    if (len === 0) return false;
    return 'indeterminate';
  },
  resetRowSelection: () => {
    if (Object.keys(get().selectedIdsList).length) {
      set({ selectedIdsList: {} });
    }
  }
});